export enum ApplicationId {
  consoleHelp = "consoleHelp",
  createProject = "createProject",
  llsInterpretingService = "llsInterpretingService",
  machineTranslation = "machineTranslation",
  pbiReports = "pbiReports",
  reports = "reports",
  xtrfDashboard = "xtrfDashboard"
}
